import { LogoMark } from "./Header";

export const Footer = () => {
  return (
    <footer className="bg-[#093125] border-t border-[#F2EDE1]/10" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-14">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-10">
          <LogoMark dark={false} />
          <nav className="flex flex-wrap gap-x-10 gap-y-4" data-testid="footer-nav">
            {[
              { label: "Services", href: "#services" },
              { label: "Selected Work", href: "#work" },
              { label: "Our Approach", href: "#approach" },
              { label: "FAQ", href: "#faq" },
              { label: "Contact", href: "#contact" },
            ].map((l) => (
              <a
                key={l.label}
                href={l.href}
                data-testid={`footer-${l.label.toLowerCase().replace(/\s/g, "-")}-link`}
                className="eyebrow text-[#F2EDE1]/60 hover:text-[#A6874E] transition-colors duration-300"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
        <div className="mt-12 pt-8 border-t border-[#F2EDE1]/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <span className="text-[11px] text-[#F2EDE1]/40">©2026 Elevora — Growth Through Strategy</span>
          <span className="text-[11px] text-[#F2EDE1]/40">Digital growth agency, working worldwide</span>
        </div>
      </div>
    </footer>
  );
};
